import { QueryClient } from "@tanstack/react-query";

// Single QueryClient instance shared across the app. Imported by
// `app/providers.tsx`. Tests that need their own QueryClient should
// instantiate one with these same defaults rather than reuse this one.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
